import { AbstractControl, Validators } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class NumericAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email: 'Este campo es requerido',
            bad_email_two: 'This field is required'
        },
        'en-US': {
            bad_email: 'Este campo requiere solo números',
            bad_email_two: 'This field requires only numbers'
        }
    };
    protected static placeholder: any = {
        'es-AR': 'Número de tu cuenta de',
        'en-US': 'Account number of'
    };
    public getLabelToAccountType(): string {
        return NumericAccountValidator.label[NumericAccountValidator.lang] ?? NumericAccountValidator.label['es-AR'];
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any = NumericAccountValidator.errors[NumericAccountValidator.lang] ?? NumericAccountValidator.errors['es-AR'];
        if (Validators.required(control) !== null) {
            return { forbiddenName: error.bad_email };
        }
        if (Validators.pattern('[0-9]*')(control) !== null) {
            return { forbiddenName: error.bad_email_two };
        }

        return null;
    }
}
